<template>
  <div v-if="hasPromocode" class="promocode-component">
    <section class="d-flex align-center promocode-wrapper">
      <!-- Только промокод: скидку степпер показывает отдельной строкой под итогом -->
      <promo-code-badge
        class="promocode-name font-weight-medium"
        :promo-code="promocode"
        :hide-fox-coin-pay="false"
      />
    </section>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PromoCodeAction from '@/models/enums/PromoCodeAction'

  export default {
    name: 'PromocodeShort',
    props: {
      promocode: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        order: state => state.orders.currentEditOrder,
      }),
      hasPromocode () {
        return !!this.promocode
      },
      isFoxCoinPay () {
        return this.promocode &&
          this.promocode.promoCode &&
          this.promocode.promoCode.action === PromoCodeAction.FoxCoinPay
      },
      foxCoinsCountLabel () {
        return this.foxCoinsCount ? '-' + this.foxCoinsCount : 0
      },
      foxCoinsCount () {
        return this.basket ? this.basket.foxCoinsPayAmount : 0
      },
      getFullPromocodeDescription () {
        return this.promocode && this.promocode.promoCode ? this.promocode.promoCode.description : ''
      },
      getPromocodeDescription () {
        if (this.promocode && this.promocode.promoCode) {
          let descr = this.promocode.promoCode.description
          if (descr && descr.length > 58) {
            descr = descr.slice(0, 58)
            descr += '...'
          }
          return descr
        }
        return ''
      },
    },
  }
</script>

<style lang="less" scoped>
.promocode-component {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  border-radius: 10px;
  /*margin-bottom: 9px;*/
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .promocode-wrapper {
    width: 100%;
  }

  // Рамка и скругление - в PromoCodeBadge, здесь только размер, цвет и место
  .promocode-name {
    padding: 0.5em 0.36em;
    border-color: #707070;
    font-size: 1em;
    min-width: 100%;
  }

  .promocode-description {
    margin-right: 10px;

    .label {
      display: block;
      font-size: 12px;
      color: #7B7B7B;
    }

    .foxcoins-pay {
      font-size: 20px;
      color: #fe9923;
      display: flex;
      align-items: center;
      line-height: 1.2;
      font-weight: bold;

      &:after {
        display: inline-block;
        height: 24px;
        width: 24px;
        content: '';
        background: url("/img/icons/setcoins-icon.svg") no-repeat center center;
        background-size: contain;
        margin-left: 2px;
        margin-top: -2px;
      }

    }

    .description {
      cursor: default;
      max-height: 72px;
      max-width: 250px;
      text-overflow: ellipsis;
      overflow-y: hidden;
      word-wrap: break-word;
    }
  }

  .icon {
    svg {
      width: 40px;
      height: 35px;
    }
  }
}
</style>
